// A team's share card (course_teams/_share_card): report each tap as
// team_shared to CourseShareEventsController.
//
// gift_share.js's sibling, and NOT IN packs/ for the same reason; imported by
// packs/application.js beside it. The copy button and the native share sheet
// on the card are gift_share.js's own ([data-gift-copy],
// [data-gift-native-share]), so this file only reports. The card works with
// neither: WhatsApp is a plain link and the field is selectable. A report
// that fails is one row the admin's count misses; the share itself is never
// held up.
//
// The team is named by its prefixed id (data-team-id), never by its share
// token: the token is the link, and it has no business in an analytics row.

function recordTeamShare(control) {
  const card = control.closest("[data-team-share]");
  if (!card || !card.dataset.shareEventsUrl) return;

  const token = document.querySelector('meta[name="csrf-token"]');
  const body = new URLSearchParams({ team_id: card.dataset.teamId, channel: control.dataset.shareChannel });

  try {
    fetch(card.dataset.shareEventsUrl, {
      method: "POST",
      body,
      keepalive: true,
      credentials: "same-origin",
      headers: token ? { "X-CSRF-Token": token.content } : {}
    }).catch(() => {});
  } catch (_error) {
    // The count misses one tap; the reader notices nothing.
  }
}

document.addEventListener("click", (event) => {
  const control = event.target.closest("[data-team-share] [data-share-channel]");
  if (control) recordTeamShare(control);
});
